import React from "react";
const Button = ({type, style, title, onClick ,inlineStyle,btnId}) => {
    return (
        <button type={type} onClick={onClick} id={btnId} className={style} style={inlineStyle}>{title}</button>
    )
}
export default Button;

